// extracted by mini-css-extract-plugin
export var copy = "randoms-module--copy--f2896";
export var img = "randoms-module--img--6637c";
export var quote = "randoms-module--quote--3639c";
export var quote_center = "randoms-module--quote_center--6da75";
export var quote_right = "randoms-module--quote_right--3b156";
export var stamp = "randoms-module--stamp--df4e1";